import { InteractionRatingType } from '~types'

const ratingValues = InteractionRatingType.options.map((option) => option.value)
const minScore = Math.min(...ratingValues)
const maxScore = Math.max(...ratingValues)

/**
 * Tooltip descriptions for AI interaction evaluation metrics.
 * These are used in both the log table headers, the filter drawer, and the evaluation card in the log content view.
 */
export const EVALUATION_TOOLTIPS = {
  summary: 'An AI-generated summary describing the key points and context of the interaction.',
  score: `An AI-generated metric ranging from ${minScore}-${maxScore} that evaluates how effectively the agent served the user's needs, considering information quality and interaction efficiency.`,
  outcome:
    "An AI-generated classification describing the outcome of the interaction and how effectively the agent addressed the user's needs.",
  sentiment:
    'An AI-generated classification describing the sentiment of a user toward the agent based on their interaction.',
  category: 'An AI-generated classification of the topic or subject matter of the interaction.',
  handled:
    "An AI-generated assessment of whether the user's request was successfully addressed during the interaction.",
  turns: 'The number of back-and-forth exchanges between user and agent during the interaction.',
  toolCalls: 'The number of external tools invoked by the agent during the interaction.',
  duration: 'The total time elapsed from the start to the end of the interaction.',
} as const
